var $ = require('jquery');
var TorsoView = require('backbone-torso/modules/View');

/**
 * Default View for the content of the accordion widget
 *
 */
module.exports = TorsoView.extend({
  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this view
   */
  initialize: function(options) {
    if (options.accordionContentTemplate) {
      this.template = options.accordionContentTemplate ;
    } else if (options.accordionContentMessageKey) {
      this.template = $.i18n.prop(options.accordionContentMessageKey);
    } else {
      throw 'Either accordionContentView, accordionContentTemplate, or accordionContentMessageKey must be provided when instantiating an accordion.';
    }
  }
});
